var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"md-3"},[_c('div',{attrs:{"id":"b-card-title"}},[_vm._v(_vm._s(_vm.title))]),_c('b-card-text',[_vm._v("\n      Some quick example text to build on the card title.\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }